// React
import React, { useEffect } from 'react';

// Styles
import '../styles/Timer.css';

// Contexts
import { useTimer } from '../contextes/useTimer';

// Props du composant Timer
type timerProps = {
    setIsPaused: React.Dispatch<React.SetStateAction<boolean>>;
    isPenaltyAdded: boolean;
};

// Composant Timer pour le jeu
// Affiche le temps écoulé et un bouton pause
const Timer: React.FC<timerProps> = ({ setIsPaused, isPenaltyAdded }) => {
    // Récupère le timer et les fonctions du contexte Timer
    const { time, startTimer, stopTimer, formatTime } = useTimer();

    // Démarre le timer au montage du composant
    useEffect(() => {
        startTimer();
    }, []);

    // Gère le clic sur le bouton pause
    const handlePause = () => {
        stopTimer();
        setIsPaused(true);
    };

    return (
        <div className='game-timer'>
            <img
                src='./images/timer-icon-alternate.png'
                alt='Timer'
                className='game-timer-icon'
            />

            <span>{formatTime(time)}</span>
            {isPenaltyAdded && <div className='game-timer-penalite'>- 5 sec</div>}

            <div className='game-timer-btn-wrap'>
                <button onClick={handlePause}>
                    <img
                        src='./images/pause-icon.png'
                        alt='Pause Icon'
                    />
                </button>
                <div className='button-shadow'></div>
            </div>
        </div>
    );
};

export default Timer;
